import { T } from "../constants/theme";

export default function Select({
  label,
  value,
  onChange,
  options = [],
  required,
  error,
})  {
  return (
    <div style={{ marginBottom: 18 }}>
      <label
        style={{
          display: "block",
          fontSize: 13,
          fontWeight: 600,
          color: T.gray800,
          marginBottom: 5,
        }}
      >
        {label} {required && <span style={{ color: T.saffron }}>*</span>}
      </label>

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          padding: "10px 13px",
          borderRadius: 8,
          border: `1.5px solid ${error ? T.red : T.gray200}`,
          fontSize: 14,
          color: value ? T.gray800 : T.gray400,
          background: T.white,
          outline: "none",
          boxSizing: "border-box",
          appearance: "none",
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2394A3B8' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 13px center",
        }}
      >
        {options.map((o) => (
          <option key={o.value ?? o} value={o.value ?? o}>
            {o.label ?? o}
          </option>
        ))}
      </select>

      {error && (
        <p style={{ fontSize: 12, color: T.red, marginTop: 4 }}>
          ⚠ {error}
        </p>
      )}
    </div>
  );
}